var _style, _g, _g2, _g3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgButtonMute(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 62 62",
    style: {
      enableBackground: "new 0 0 62 62"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#AB9834;}\n\t.st1{fill:#D2D2D2;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31,62C13.9,62,0,48.1,0,31C0,13.9,13.9,0,31,0c17.1,0,31,13.9,31,31C62,48.1,48.1,62,31,62z M31,1 C14.5,1,1,14.5,1,31s13.5,30,30,30s30-13.5,30-30S47.5,1,31,1z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.3,40.8c-0.1,0-0.2,0-0.3-0.1l-7.8-6.4H21c-0.3,0-0.5-0.2-0.5-0.5v-6.5c0-0.3,0.2-0.5,0.5-0.5h5.4l7.6-6.2 c0.1-0.1,0.4-0.1,0.5-0.1c0.2,0.1,0.3,0.3,0.3,0.5v19.3c0,0.2-0.1,0.4-0.3,0.5C34.4,40.8,34.4,40.8,34.3,40.8z M21.5,33.3h4.9 c0.1,0,0.2,0,0.3,0.1l7.1,5.8V22.1l-6.9,5.6c-0.1,0.1-0.2,0.1-0.3,0.1h-5.1V33.3z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.2,34.8c-0.2,0-0.3-0.1-0.4-0.2c-0.2-0.2-0.1-0.5,0.1-0.7c1.1-0.8,1.7-2,1.7-3.2c0-1.2-0.7-2.3-1.8-3.2 c-0.2-0.2-0.3-0.5-0.1-0.7c0.2-0.2,0.5-0.3,0.7-0.1c1.4,1,2.2,2.5,2.2,4c0,1.5-0.8,3-2.1,4C38.4,34.8,38.3,34.8,38.2,34.8z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15.4,
    y: 30.5,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -12.8612 31.0498)",
    className: "st1",
    width: 31.3,
    height: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonMute);
export default __webpack_public_path__ + "static/media/button_mute.2e14e7f3582d373de31d306796a9f2ae.svg";
export { ForwardRef as ReactComponent };